import React , { useState, useEffect } from "react";
import { Suspense, lazy } from "react";
import "./App.scss";
//import Analytics from 'react-router-ga';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { TinyButton as ScrollUpButton } from "react-scroll-up-button";
import Footer from "./components/Footer/footer";
import ArticleDetail from "./pages/Articledetail/articledetail";
import CommonPages from "./pages/common/common";
import Home from "./pages/Home/home";
import PhotoDetail from "./pages/Photodetail/photodetail";
import PhotoGallery from "./pages/Photogallery/photogallery";
import Header from "./components/header/header";
import "./assets/scss/responsive.scss";
import Astrology from "./pages/Astrology/Astrology";
import ZodiacDetail from "./pages/ZodiacDetail/Zodiacdetail";
import AstrologyDetail from "./pages/AstrologyDetail/Astrologydetail";
import VideoListing from "./pages/Videos/Videos";
import VideoDetailPage from "./pages/VideoDetail/Videodetail";
import SearchResult from "./pages/searchresult/searchresult";
import videoDetail from "./pages/VideoDetail/Videodetail";
import ListingMiddleWare from "./pages/listingMiddleWare";
import CricketPage from "./pages/cricketScorecard/cricketScorecard";
import PollPage from "./pages/Poll/Poll";
import DiscussionPage from "./pages/Discussionpage/Discussionpage";
import { Helmet } from "react-helmet";
import PopUp from "./pages/PopUp";
import ReactGA from "react-ga4";
import CookieConsent  from './components/CookiesConsent/CookieConsent';
import InterstitialAd from './components/InterstitialAd/InterstitialAd'
//import ReactGA from 'react-ga';
function App() {
 // ReactGA.initialize("G-GN0TLTYTPS"); 
  
    ReactGA.initialize('G-GN0TLTYTPS');
  //  ReactGA.pageview(window.location.pathname + window.location.search);
  
  return (
    <div className="App">
      {/* popup Component */}
     {/* <PopUp /> */}
     {/* <Helmet>
                                    <script src="/js/popup.js" async ></script>
                                </Helmet>
                                <div class="contest_popup_wrap" id="festival_popup">
                                    <div class="contest_bann_img">
                                        <button class="cont_close_btn" aria-label="webdunia"><img src={require("./assets/img/navratri/f_closebtn.png").default} /></button>
                                        <a href="https://play.google.com/store/apps/details?id=com.webdunia.app&hl=en"><img src={require('./assets/img/diwali/en-web.png').default} /></a>
                                    </div>
                                </div> */}

      {/* header component  */}
      <Header />
      <div className="mid_content"> 
      <Router>
      
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/home-page" component={Home} />
          <Route exact path="/videos" component={VideoListing} />
          <Route exact path="/video-details" component={VideoDetailPage} />
          <Route path="/astrology/zodiac/" component={ZodiacDetail} />
          <Route
            path="/astrology-weekly-horoscope-details"
            component={AstrologyDetail}
          />
          <Route
            path="/astrology-monthly-horoscope-details"
            component={AstrologyDetail}
          />
          <Route
            path="/astrology-yearly-horoscope-details"
            component={AstrologyDetail}
          />
          {/* <Route exact path="/static" component={Static}/>  */}
          <Route exact path="/photo-gallery" component={PhotoGallery} />
          <Route
            exact
            path={/.photo-gallery.{0,}([0-9])(\.htm.*)/g}
            component={PhotoDetail}
          />
          <Route
            exact
            path="/astrology-daily-horoscope"
            component={Astrology}
          />
          <Route
            exact
            path="/astrology-weekly-horoscope"
            component={Astrology}
          />
          <Route
            exact
            path="/astrology-monthly-horoscope"
            component={Astrology}
          />
          <Route
            exact
            path="/astrology-yearly-horoscope"
            component={Astrology}
          />
          <Route
            exact
            path="/poll/list"
            component={PollPage}
          />

          <Route
            exact
            path="/discussion/list"
            component={DiscussionPage}
          />
          <Route exact path="/cricket-score-card" component={CricketPage} />
          <Route exact path={/^.cricket-score-card.[0-9]+\.html$/} component={CricketPage} />
          <Route exact path="/cricket-fixtures" component={CricketPage} />
          <Route
            path={/.{0,}([0-9])(\.html|\.htm).{0,}/g}
            component={ArticleDetail}
          />

          {/* <Route  path={/.{0,}([0-9])(\.html.*)/g} component={ArticleDetail}/> */}
          <Route exact path="/articledetail" component={ArticleDetail} />
          <Route exact path="/advertise-with-us" component={CommonPages} />
          <Route exact path="/disclaimer" component={CommonPages} />
          <Route exact path="/contact-us" component={CommonPages} />
          <Route exact path="/rate-app" component={CommonPages} />
          <Route exact path="/share-the-app" component={CommonPages} />
          <Route exact path="/feedback" component={CommonPages} />
          <Route exact path="/privacy-policy" component={CommonPages} />
          <Route exact path="/about-us" component={CommonPages} />

          <Route exact path={/.wdvideo.*/g} component={videoDetail} />
          <Route exact path={/.photo-gallery.*/g} component={PhotoGallery} />
          {/* <Route exact path='/RSS.xml' component={RSS}/>  */}
          <Route exact path={/.tags.*/g} component={SearchResult} />
          <Route exact path={/[\w\/_\-]+/g} component={ListingMiddleWare} />
          {/* <Route exact path="*" component={PageNotFound}/> */}
        </Switch>
       
      </Router>
      </div>
      <InterstitialAd />
      <CookieConsent  />
      <Footer />
      <ScrollUpButton ContainerClassName="backtotop_btn" />
    </div>
  );
}

export default App;
